// managementModalUtils.js
import API_BASE_URL from "../../../../../Constants";

// Regular expressions for validation
const stateRegex = /^[A-Z]{2}$/;
const zipRegex = /^\d{5,}$/; // Zip code must be at least 5 digits



export const validateBuildingForm = (formData) => {
  const errors = {};
  if (!formData.buildingSite || formData.buildingSite.trim() === '') {
    errors.buildingSite = 'Building Site is required';
  }
  if (!formData.buildingReference || formData.buildingReference.trim() === '') {
    errors.buildingReference = 'Building Reference is required';
  }
  if (!formData.location || formData.location.trim() === '') {
    errors.location = 'Location is required';
  }
  if (formData.buildingType == null || formData.buildingType === '') {
    errors.buildingType = 'Building Type is required';
  }
  return errors;
};


export const validateContactForm = (formData) => {
  const errors = {};

  // Required field validation
  if (!formData.contactName || formData.contactName.trim() === '') {
    errors.contactName = 'Name is required';
  }
  if (!formData.phone1 || formData.phone1.trim() === '') {
    errors.phone1 = 'Primary Phone Number is required';
  }
  if (!formData.emailAddress || formData.emailAddress.trim() === '') {
    errors.emailAddress = 'Email Address is required';
  }
  if (formData.contactLevel == null || formData.contactLevel === '' || formData.contactLevel === 0) {
    errors.contactLevel = 'Contact Level is required';
  }

  // Zip code validation
  if (formData.zip && !zipRegex.test(formData.zip)) {
    errors.zip = 'Zip code must be at least 5 digits';
  }

  // State validation
  if (formData.state && !stateRegex.test(formData.state)) {
    errors.state = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  return errors;
};

export const validateCustomerForm = (formData) => {

  const errors = {};

  // Required field validation
  if (!formData.customerName) {
    errors.customerName = 'Customer Name is required';
  }
  if (!formData.customerNumber) {
    errors.customerNumber = 'Customer Number is required';
  }
  if (!formData.address) {
    errors.address = 'Address is required';
  }
  if (!formData.city) {
    errors.city = 'City is required';
  }
  if (!formData.state) {
    errors.state = 'State is required';
  }
  if (!formData.zip) {
    errors.zip = 'Zip is required';
  }

  // Zip code validation
  if (formData.zip && !zipRegex.test(formData.zip)) {
    errors.zip = 'Zip code must be at least 5 digits';
  }

  // State validation
  if (formData.state && !stateRegex.test(formData.state)) {
    errors.state = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  // Zip code validation
  if (formData.billingZip && !zipRegex.test(formData.billingZip)) {
    errors.billingZip = 'Zip code must be at least 5 digits';
  }

  // State validation
  if (formData.billingState && !stateRegex.test(formData.billingState)) {
    errors.billingState = 'State must be exactly 2 uppercase letters (e.g., "NY")';
  }

  return errors;
};

export const mgmtContactsToCustomerContacts = (mgmtContacts, customerID) => {
  return mgmtContacts.map((contact) => {
    return {

      customerId: customerID,
      contactId: contact.contactId,
      mainContact: contact.mainContact,
      agentContact: contact.agentContact,
      collectionsContact: contact.collectionsContact,

    };
  });
}

export const getManagementContactsForCustomer = async (managementId) => {

  const response = await fetch(`${API_BASE_URL}/api/setup/mgmtco-contact-intersections/management-company/${managementId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',

    },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch management contacts: ${response.status}`);
  }

  const managementContacts = await response.json();
  console.log('managementContacts:', managementContacts);

  return managementContacts;


}

export const createCustomerContacts = async (contacts, customerID) => {
  const customerContacts = mgmtContactsToCustomerContacts(contacts, customerID);

  try {
    const response = await fetch(`${API_BASE_URL}/api/setup/customer-contact-intersections/update/${customerID}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(customerContacts),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error creating contacts:', error);
  }
}